import React from 'react';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import { useMyUserId } from '../../../../../../data/hooks/sessionHooks';
import UserName from '../../../../../elements/UserName';

function MeetingUserName(props) {
    const { meeting, user } = props,
        selfUserIf = useMyUserId(),
        i18n = useI18n();

    if (selfUserIf == user.id) {
        return <i>{i18n['meeting.organizer.title.self']}</i>;
    }

    if (user.id == meeting.initiator.id) {
        return (
            <>
                <UserName user={user} /> ({i18n['meeting.organizer.title']})
            </>
        );
    }

    return <UserName user={user} />;
}

export default MeetingUserName;
